import { createAction } from 'typesafe-actions';

export const openSidebar = createAction('sidebar/open');
export const closeSidebar = createAction('sidebar/close');
